import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import auth from "../auth";

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  if (auth.isAuthenticated()) {
    return children;
  } else {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }
};